import React from "react";
import { Slider } from "@/components/ui/slider";
import { format } from "date-fns";
import { User, AppWindowMac } from "lucide-react";
import { meters_to_km_velocity } from "@/utils/variables";
import { useUserContext } from "@/context/UserContext";

interface TrackRouteProps {
  currentPosition: any;
  onSliderChange: (value: number[]) => void;
  sliderValue: number;
}

const TrackRoute: React.FC<TrackRouteProps> = ({
  currentPosition,
  onSliderChange,
  sliderValue,
}) => {
  const {decodedToken} = useUserContext()

  return (
    <div className={`absolute ${decodedToken?.settings.settings_type === 'rental' ? "bottom-20" : "bottom-5"} left-50 z-20 bg-white p-4 w-200 rounded-2xl font-bold`}>
      <p className="pb-3">Track Route</p>
      <Slider
        value={[sliderValue]}
        onValueChange={onSliderChange}
        max={100}
        step={1}
      />
      <div className="relative pt-4 text-sm text-gray-700">
        {currentPosition && (
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-1">
              <User
                className="w-5 h-5"
                style={{
                  color:
                    currentPosition?.variables.seatSensor ||
                    currentPosition?.variables.prezenca ||
                    currentPosition?.variables.pasagjer
                      ? "#ff4d4d"
                      : "#00ff00",
                }}
              />
              <span className="text-xs">Pasager</span>
            </div>

            <div className="flex items-center space-x-1">
              <AppWindowMac
                className="w-5 h-5"
                style={{
                  color:
                    currentPosition?.variables.taxiMeter || currentPosition?.variables.taximeter
                      ? "#ff4d4d"
                      : "#00ff00",
                }}
              />
              <span className="text-xs">Taximeter</span>
            </div>

            {currentPosition?.utc != null && (
              <div className="ml-auto text-xs text-gray-600">
                <span className="font-medium">Time:</span>{" "}
                {format(currentPosition?.utc, "dd MMMM yyyy HH:mm")}{" "}
              </div>
            )}

            <div className="ml-auto text-xs text-gray-600">
              <span className="font-medium">Speed:</span>{" "}
              {!isNaN(currentPosition.variables.speed) ? (Math.round(
                currentPosition.variables.speed * meters_to_km_velocity,
              )) : 'N/A'}{" "}
              km/h
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TrackRoute;